import './TimelineSkeleton.css';

function SkeletonCard() {
  return (
    <div className="timeline-skeleton__card">
      <div className="timeline-skeleton__content">
        <div className="timeline-skeleton__bar timeline-skeleton__bar--title" />
        <div className="timeline-skeleton__bar timeline-skeleton__bar--body-long" />
        <div className="timeline-skeleton__bar timeline-skeleton__bar--body-medium" />
        <div className="timeline-skeleton__bar timeline-skeleton__bar--meta" />
      </div>
    </div>
  );
}

export function TimelineSkeleton() {
  return (
    <>
      {Array.from({ length: 5 }, (_, i) => (
        <SkeletonCard key={i} />
      ))}
    </>
  );
}
